import React from 'react';
import { FILTER_STRATEGY } from '../../../components/connex-data-grid/util';

export const prototype = {
  id: '',
  name: '',
  maximumGrossVehicleWeight: '',
  maximumNetVehicleWeight: '',
  targetGrossVehicleWeight: '',
  targetNetVehicleWeight: '',
  status: 'ACTIVE',
};

export const columns = [
  { key: 'id', name: 'ID' },
  { key: 'name', name: 'Name' },
  { key: 'maximumGrossVehicleWeight', name: 'Max GVW' },
  { key: 'maximumNetVehicleWeight', name: 'Max Net' },
  { key: 'targetGrossVehicleWeight', name: 'Target Gross' },
  { key: 'targetNetVehicleWeight', name: 'Target Net' },
  {
    key: 'status',
    name: 'Status',
    filterStrategy: FILTER_STRATEGY.EQUALS,
    filterComponent: ({ innerRef, ...props }) => {
      return (
        <select ref={innerRef} {...props}>
          <option value="" />
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      );
    },
  },
];
